export function Platzhalter({ name, text }: { name: string; text?: string }) {
  return (
    <section>
      <h1>{name}</h1>
      <p className="hinweis">{text ?? 'Diese Seite gibt es nicht.'}</p>
    </section>
  );
}
